import { useLoader } from "@/context/loaderContext";
import api from "@/components/customAxios/Axios"
import { useToast } from "../toast";
const ViewPaymentHistory = ({ paymentHistory }: { paymentHistory: any }) => {
	const { setLoading } = useLoader()
	const toast = useToast()
	const downloadReceipt = async (id: string | null) => {
		try {
			setLoading(true);
			const response = await api.post("/generate_invoice", {
				payment_id: id
			});

			const pdfUrl = response.data?.invoice_pdf_url;
			if (pdfUrl) {
				const link = document.createElement("a");
				link.href = pdfUrl;
				link.setAttribute("download", ""); // Optional: browser will use filename from server
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		} catch (error: any) {
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Error Fetching Receipt",
				description: error.response?.data?.error || error.response?.data?.message || "An unknown error occurred",
				open: true,
			});

		} finally {
			setLoading(false);
		}
	};


	return (
		<div className="space-y-5">
			{/* Breadcrumb */}

			{/* Payment Cards */}
			<table className="min-w-full  ">
				<thead className=" text-">
					<tr>
						<th className="px-4 py-2 text-left text-xs font-medium uppercase">Receipt ID</th>
						<th className="px-4 py-2 text-left text-xs font-medium uppercase">Status</th>
						<th className="px-4 py-2 text-left text-xs font-medium uppercase">Plan</th>
						<th className="px-4 py-2 text-left text-xs font-medium uppercase">Amount</th>
						<th className="px-4 py-2 text-left text-xs font-medium uppercase">Created</th>
						<th className="px-4 py-2 text-left text-xs font-medium uppercase">Download Receipt</th>
					</tr>
				</thead>
				<tbody className=" divide-y  space-y-2 divide-gray-200 ">
					{paymentHistory.map((payment: any, index: number) => (
						<tr key={index} className="mb-2">
							<td className="px-4 py-2  ">
								{payment.receipt_numnber}
							</td>
							<td className="px-4 py-2  mb-2">
								<span className={`text-center p-2 px-3  rounded-3xl text-sm  ${payment.payment_status === "completed"
									? "bg-[#BDE4C3] text-[#438437]" : "bg-[#F7C5C5] text-[#CA4F4F]"}`}  >

									{payment.payment_status === "completed" ? "Paid" : "Fail"}
								</span>
							</td>
							<td className="px-4 py-2">
								{payment.subscription_plan_name}
							</td>
							<td className="px-4 py-2">${payment.amount}</td>
							<td className="px-4 py-2">
								{new Date(payment.updated_at).toLocaleString('en-US', {
									month: 'short',
									day: 'numeric',
									year: 'numeric',
									hour: 'numeric',
									minute: '2-digit',
									hour12: true,
								})}
							</td>
							<td className="py-2 flex justify-center text-blue-400 cursor-pointer">
								<button onClick={() => downloadReceipt(payment.id)}>
									<svg
										width="29"
										height="24"
										viewBox="0 0 29 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clipPath="url(#clip0_77_1708)">
											<path
												d="M9.66699 18L14.5003 22.8M14.5003 22.8L19.3337 18M14.5003 22.8V12"
												stroke="#3770ED"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M25.2307 19.308C26.2813 18.5744 27.0691 17.5274 27.4798 16.319C27.8905 15.1106 27.9029 13.8036 27.515 12.5878C27.1271 11.372 26.3592 10.3105 25.3227 9.55749C24.2862 8.80446 23.035 8.39902 21.7507 8.40002H20.2282C19.8648 6.99346 19.1848 5.68711 18.2395 4.57931C17.2941 3.47151 16.108 2.59113 14.7705 2.00444C13.4329 1.41775 11.9788 1.14005 10.5175 1.19224C9.05625 1.24442 7.62595 1.62514 6.33429 2.30573C5.04263 2.98632 3.92326 3.94904 3.06047 5.12141C2.19767 6.29379 1.61393 7.64527 1.35318 9.07412C1.09244 10.503 1.16148 11.9719 1.55512 13.3704C1.94876 14.769 2.65673 16.0606 3.62574 17.148"
												stroke="#3770ED"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</g>
										<defs>
											<clipPath id="clip0_77_1708">
												<rect width="29" height="24" fill="white" />
											</clipPath>
										</defs>
									</svg>
								</button>

							</td>
						</tr>
					))}
				</tbody>
			</table>

		</div>
	);
};

export default ViewPaymentHistory;
